var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.9618,
    height: 26.7785,
    rx: 13.3893,
    transform: "matrix(-1 0 0 1 76.8174 3.91602)",
    fill: "#FFCCE4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 53.9618,
    height: 26.7785,
    rx: 13.3893,
    transform: "matrix(-1 0 0 1 57.1445 17.3057)",
    fill: "#FFCCE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 53.9618,
    height: 26.7785,
    rx: 13.3893,
    transform: "matrix(-1 0 0 1 76.8174 3.91602)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 53.9618,
    height: 26.7785,
    rx: 13.3893,
    transform: "matrix(-1 0 0 1 57.1445 17.3057)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.f6bcb114622b092fadf8265d6854e11d.svg";
export { ForwardRef as ReactComponent };